var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "calendar-wrapper" }, [
    _c("div", { staticClass: "calendar-header" }, [
      _c("div", { staticClass: "left-ring" }),
      _vm._v(" "),
      _c("div", { staticClass: "right-ring" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "\n        month-text\n        h-100\n        d-flex\n        justify-content-center\n        align-items-center\n      "
        },
        [_vm._v("\n      " + _vm._s(_vm.monthText) + "\n    ")]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "calendar-body d-flex justify-content-center align-items-center"
      },
      [_c("div", { domProps: { innerHTML: _vm._s(_vm.dayText) } })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b7311a44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7311a44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/events/CalendarIcon.vue
// module id = null
// module chunks = 